import saamiLogo from "../Img/saami_logo_256x297.jpg";

export default function Logo() {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        background: "var(--bg)",
        animation: "logoFadeIn 0.6s ease both",
      }}
    >
      {/* Watermark-style logo, blended into the page background like a shadow */}
      <img
        src={saamiLogo}
        alt="SAAMI Tradestar Logistics"
        style={{
          width: "min(28vw, 260px)",
          height: "auto",
          opacity: 0.35,
          mixBlendMode: "multiply",
          filter: "grayscale(20%)",
          userSelect: "none",
          pointerEvents: "none",
        }}
      />

      {/* Foreground text overlay */}
      <div
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-head)",
            fontWeight: 800,
            fontSize: 32,
            letterSpacing: ".05em",
            color: "var(--text)",
          }}
        >
          SAAMI TRADESTAR
        </div>
        <div
          style={{
            fontFamily: "var(--font-body)",
            fontSize: 14,
            fontWeight: 600,
            color: "var(--accent)",
            letterSpacing: ".1em",
            textTransform: "uppercase",
            marginTop: 4,
          }}
        >
          Logistics Ltd
        </div>
        <div
          style={{
            fontFamily: "var(--font-body)",
            marginTop: 20,
            fontSize: 11,
            fontWeight: 600,
            color: "var(--muted)",
            letterSpacing: ".14em",
            textTransform: "uppercase",
          }}
        >
          Innovative Logistics Management System
        </div>
      </div>

      <style>{`
        @keyframes logoFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
    </div>
  );
}